import React, { useRef } from 'react';
import styled from 'styled-components';
import { Text, Headline } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { generateMercantileValue } from '../../../utils/generateMercantileValue';
import mapContext from '../../../contexts/map-context';
import { FiveStarRating } from '../../common/FiveStarRating/FiveStarRating';
import { RatingDisclaimer } from '../../common/RatingDisclaimer/RatingDisclaimer';
import { messages } from '../../../i18n/messages';

const CenterPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  color: #333333;
`;

const RatingDisclaimerRow = styled.div`
  display: flex;
`;

const AverageRatingText = styled(Text)`
  display: flex;
  align-items: center;
`;

const FiveStarRatingRow = styled.div`
  margin-top: 12px;
`;

export const CenterPanel = () => {
  const { selectedDealerId, dealerRatings } = mapContext.useMapState();
  const rating = dealerRatings?.[selectedDealerId || ''] || 0;
  const averageRatingLabel = useI18n(messages.five_star_average_rating);
  const ratingRef = useRef(null);
  return (
    <CenterPanelContainer ref={ratingRef}>
      <Headline tag="h2" variant={{ order: '2', type: 'headline', weight: 'bold' }}>
        {generateMercantileValue(rating) || ''}
      </Headline>
      <FiveStarRatingRow>
        <FiveStarRating rating={rating} />
      </FiveStarRatingRow>
      <RatingDisclaimerRow className="test">
        <AverageRatingText variant={{ order: '2', style: 'normal', type: 'copy' }}>
          {averageRatingLabel}
        </AverageRatingText>
        <RatingDisclaimer />
      </RatingDisclaimerRow>
    </CenterPanelContainer>
  );
};
